import React from "react";
import BaseComponent from "../../../common/BaseComponent";
import { Table } from "antd";
import "./index.scss";
import NormalToolTip from "../../toolTip";
import { PreviewFileLink } from "app/pages/previewFile";

export default class HistoricalVersionTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      dataSource: [],
    };
    // @ts-ignore
    this.columns = [
      {
        title: "File Name",
        dataIndex: "fileName",
        key: "fileName",
        ellipsis: true,
        render: (text: any, record: any) => (
          <NormalToolTip
            element={
              <PreviewFileLink fileId={record.fileId} fileName={text}>
                {text}
              </PreviewFileLink>
            }
            title={text}
            placement="topLeft"
            arrowPointAtCenter={false}
          />
        ),
      },
      {
        title: "Uploaded Date",
        dataIndex: "uploadedDate",
        key: "uploadedDate",
        render: (text: any) => (
          <NormalToolTip
            element={this._formateDate(text)}
            title={this._formateDate(text)}
            placement="top"
          />
        ),
      },
      {
        title: "Uploaded By",
        dataIndex: "uploadedByName",
        key: "uploadedBy",
        render: (text: any) => <NormalToolTip element={text} title={text} placement="top" />,
      },
    ];
  }
  render() {
    return (
      <div className="historicalVersionTable">
        {/* @ts-ignore */}
        <Table dataSource={this.props.dataSource} columns={this.columns} pagination={false} />
      </div>
    );
  }
}
